import Vue from 'vue';
import vmList from './vm-list';

let vm;

const destory = (content) => {
  let item = content.name;
  if (vmList[item]) {
    document.querySelector('#app').removeChild(vmList[item].$el);
    vmList[item].$destroy();
    delete vmList[item];
  }
};

const initVm = (content, vueContent) => {
  vmList[content.name] = new vueContent().$mount();
  document.querySelector('#app').appendChild(vmList[content.name].$el);
};

export default (content, options, callback) => {
  if (!content) {
    throw new Error({ error: '目标组件必传' });
  }
  if (!content.name) {
    throw new Error({ error: '组件名称必传' });
  }
  return new Promise((resolve, reject) => {
    const vueContent = Vue.extend(content);
    console.log(vmList);
    if (vmList[content.name]) {
      destory(content);
    }
    initVm(content, vueContent);
    // !vmList[content.name] && initVm(content,vueContent);
    vm = vmList[content.name];
    setTimeout(() => {
      vm.show = true;
    }, 100);
    vm.params = { ...options };
    vm.$on('sure', (data, otherData) => {
      vmList[content.name].show = false;
      if (otherData) {
        resolve({ data, otherData });
      } else {
        resolve(data);
      }
    });
    vm.$on('close', () => {
      reject(new Error({ error: true }));
      vmList[content.name].show = false;
    });
    vm.$on('success', (data) => {
      if (callback) {
        callback();
      }
      resolve(data);
    });
    vm.$on('error', (data) => {
      let error = { data, tip: true };
      console.log(error);
      reject(error);
    });
    vm.$on('destory', () => {
      setTimeout(() => {
        destory(content);
      }, 100);
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/popup-fun/index.js